import React from "react";

/**
 * Resumen al pulsar «Finalizar atención» con las 4 obligatorias completas pero
 * recomendadas pendientes. Distingue claramente BLOQUEOS de AVISOS. El médico
 * puede continuar. El endpoint de finalizar es el que ya existe.
 */
export default function ResumenFinalizar({ bloqueos, avisos, onCancelar, onConfirmar, confirmando }) {
  return (
    <div className="cev__overlay" role="dialog" aria-modal="true" aria-labelledby="cev-resumen-h" onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className="cev__panel" style={{ width: "min(460px,100%)", height: "auto", maxHeight: "90vh", margin: "auto", borderRadius: "var(--radius-panel)", borderLeft: 0 }}>
        <div className="cev__panel-head">
          <h3 id="cev-resumen-h">Finalizar atención</h3>
        </div>
        <div className="cev__panel-body">
          {bloqueos.length > 0 && (
            <>
              <div className="cev__req cev__req--ob" style={{ marginBottom: 6 }}>No se puede cerrar</div>
              {bloqueos.map((s) => (
                <div key={s.id} className="cev__estudio">
                  <span className="cev__mk cev__mk--miss" aria-hidden="true" />
                  <span style={{ flexGrow: 1, color: "var(--warning-text)", fontWeight: 500 }}>{s.titulo}</span>
                  <span className="cev__tag cev__tag--amber">Obligatoria</span>
                </div>
              ))}
            </>
          )}

          {avisos.length > 0 && (
            <>
              <div className="cev__req" style={{ margin: "12px 0 6px" }}>Avisos · se puede cerrar igual</div>
              {avisos.map((s) => (
                <div key={s.id} className="cev__estudio">
                  <span className="cev__mk cev__mk--sug" aria-hidden="true" />
                  <span style={{ flexGrow: 1 }}>{s.titulo}</span>
                  <span className="cev__tag cev__tag--grey">Recomendada</span>
                </div>
              ))}
            </>
          )}

          {bloqueos.length === 0 && avisos.length === 0 && (
            <div className="cev__empty">Todo completo. Se finalizará la atención.</div>
          )}
        </div>
        <div className="cev__panel-foot">
          <button type="button" className="cev__btn" onClick={onCancelar}>Volver</button>
          <button
            type="button"
            className="cev__btn cev__btn--pri"
            disabled={bloqueos.length > 0 || confirmando}
            onClick={onConfirmar}
          >
            {confirmando ? "Finalizando…" : "Finalizar de todos modos"}
          </button>
        </div>
      </div>
    </div>
  );
}
